import {
  APP_AFFILIATIONS_REQUEST,
  APP_AFFILIATIONS_RESPONSE,
  APP_AFFILIATIONS_FAILURE,
} from "../../../actions/types";
import { getOptions } from "../expertSummary";

const initialState = {
  isFetching: false,
  error: false,
  affiliations: [],
  totalAffiliations: 0,
  totalExperts: 0,
  totalArticles: 0,
  totalCountry: 0,
  filters: {
    size: 25,
    from: 0,
    activePage: 1,
    listType: "shortList",
    grid_name: [],
    country: [],
    SPECIALIST_CENTRES: [{
      label: "EPILEPSY CENTRE",
      value: "EPILEPSY CENTRE"
    }],
    city: "",
    region: "",
    queryText: "",
    relevants_tags: "",
    AFFILIATION_TYPE: [],
    sorting: {key: "SPECIALIST_CENTRES", order: "asc"}
  },
};

const setRequest = (state, action) => {
  const { filters = {} } = action.payload;
  return {
    ...state,
    isFetching: true,
    error: false,
    filters,
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
  };
};

const setResponse = (state, action) => {
  let {
    affiliations = [],
    totalAffiliations = 0,
    totalExperts = 0,
    totalArticles = 0,
    totalCountry = 0,
    specialistCentersOptions
  } = action.payload;

  /**
   * add filter options here
   */
   let filters = state.filters || {};
   let nameMapping = {
   };
   let keyMapping = {
     'relevant_tags': 'LABEL',
     'CITY': 'city',
   };
   let optionsKeys = ['city', 'grid_name', 'AFFILIATION_TYPE', 'LABEL', 'CITY'];
   optionsKeys.forEach(l => {
     let optionsInfo = getOptions(affiliations, l, nameMapping, action.payload);
     Object.keys(keyMapping).forEach(key => {
        if(optionsInfo[`${key}Options`]){
          optionsInfo[`${keyMapping[key]}Options`] = optionsInfo[`${key}Options`]
        }
     });

     filters = {
       ...filters,
       ...optionsInfo,
     }   

   });


  return {
    ...state,
    isFetching: false,
    error: false,
    affiliations,
    totalAffiliations,
    totalExperts,
    totalArticles,
    totalCountry,
    specialistCentersOptions,
    filters
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_AFFILIATIONS_REQUEST:
      return setRequest(state, action);

    case APP_AFFILIATIONS_RESPONSE:
      return setResponse(state, action);

    case APP_AFFILIATIONS_FAILURE:
      return setFailure(state, action);

    default:
      return state;
  }
};
